import Marquee from "react-fast-marquee";

const ITEMS = [
  "Premium Fabrics",
  "Expert Tailoring",
  "Vashi · Navi Mumbai",
  "Ready-Made Kurtas",
  "Custom Sherwanis",
  "Velvet · Cotton · Silk",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="bg-charcoal grain border-y border-charcoal py-6 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="marquee-item mx-10 inline-flex items-center gap-10">
            <span className="font-display uppercase tracking-tight text-cream text-3xl md:text-5xl font-bold">{t}</span>
            <span className="text-toga text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
